export default "__VITE_ASSET__9c27d120__"